import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { putTaricUpdate } from '../api/taric';
import { Input } from './Input/Input';

const AddCommodityCodeModal = ({ show, onHide, onSuccess }) => {
  const navigate = useNavigate();
  const [commodityCode, setCommodityCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [showResultModal, setShowResultModal] = useState(false);
  const [addedCode, setAddedCode] = useState('');
  const [resultConfig, setResultConfig] = useState({
    type: '',
    title: '',
    message: '',
  });

  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^[\d\s]*$/.test(value)) {
      setCommodityCode(value);

      const cleanValue = value.replace(/\s/g, '');
      if (cleanValue && cleanValue.length !== 10) {
        setErrorMessage('Commodity code must be exactly 10 digits');
      } else {
        setErrorMessage('');
      }
    }
  };

  const handleAdd = async () => {
    const commcode = commodityCode.replace(/\s/g, '');

    if (!commcode) {
      setErrorMessage('Commodity code is required');
      return;
    }

    if (commcode.length !== 10) {
      setErrorMessage('Commodity code must be exactly 10 digits');
      return;
    }

    setLoading(true);
    try {
      const expCommodityCode = commcode.substring(0, 8);

      const newCommCodeData = {
        commcode,
        expCommodityCode,
        add: true,
      };

      await putTaricUpdate(newCommCodeData);

      setAddedCode(commcode);

      setResultConfig({
        type: 'success',
        title: 'Success',
        message: 'Commodity code successfully added to the database.',
      });
      setShowResultModal(true);
    } catch (err) {
      let errorMessage = 'Invalid commodity code.';

      try {
        const parsed = JSON.parse(err.message);
        errorMessage = parsed.error || errorMessage;
      } catch {
        errorMessage = err.message;
      }

      setResultConfig({
        type: 'error',
        title: 'Error',
        message: errorMessage,
      });
      setShowResultModal(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setCommodityCode('');
    setErrorMessage('');
    setAddedCode('');
    setShowResultModal(false);
    onHide();
  };

  const handleResultModalOk = () => {
    setShowResultModal(false);

    if (resultConfig.type === 'success') {
      setCommodityCode('');
      setErrorMessage('');
      setAddedCode('');
      onHide();

      if (onSuccess) onSuccess();
    }
  };

  const handleViewCommodityCode = () => {
    if (addedCode) {
      navigate(`/taric/${addedCode}`);
    }
  };

  return (
    <>
      <Modal
        className="qa-checklist-modal"
        animation={false}
        show={show && !showResultModal}
        size="md"
        centered
        onHide={handleCancel}
      >
        <Modal.Header>
          <Modal.Title>Add New Commodity Code</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleCancel} />
        </Modal.Header>
        <Modal.Body>
          <div>
            <div>Enter a valid 10-digit commodity code to add to the database.</div>
            <div style={{ paddingTop: '15px', paddingBottom: '15px' }}>
              <Input
                name="commodityCode"
                type="text"
                label="Commodity Code"
                value={commodityCode}
                onChange={handleInputChange}
                placeholder="Enter 10-digit commodity code"
                hideLabel={true}
                disabled={loading}
              />
            </div>
            <span className="text-danger">{errorMessage}&nbsp;</span>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex w-100 justify-content-between">
            <button
              className="epo-continue-button small-button"
              type="button"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="button"
              className="blue-button-teams"
              onClick={handleAdd}
              disabled={loading || !commodityCode.trim() || commodityCode.replace(/\s/g, '').length !== 10}
              style={{ minWidth: 100 }}
            >
              {loading ? 'Adding...' : 'Add'}
            </button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal
        className="qa-checklist-modal"
        animation={false}
        show={showResultModal}
        size="md"
        centered
        onHide={handleResultModalOk}
      >
        <Modal.Header>
          <Modal.Title>{resultConfig.title}</Modal.Title>
          <button type="button" className="btn-close" aria-label="Close" onClick={handleResultModalOk} />
        </Modal.Header>
        <Modal.Body>
          <div>
            <div>{resultConfig.message}</div>
            {resultConfig.type === 'success' && addedCode && (
              <div style={{ marginTop: '15px', textAlign: 'center' }}>
                <p style={{ margin: '0 0 8px 0', fontSize: '14px', color: '#666' }}>View commodity code:</p>
                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    handleViewCommodityCode();
                  }}
                  style={{
                    color: '#0d6efd',
                    textDecoration: 'underline',
                    cursor: 'pointer',
                    fontSize: '16px',
                    fontWeight: 'bold',
                  }}
                >
                  {addedCode}
                </a>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex w-100 justify-content-center">
            <button className="blue-button-newload small-button" type="button" onClick={handleResultModalOk}>
              OK
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddCommodityCodeModal;
